import React from 'react';

import NavigationSubcategory from '~/src/components/navigation/subcategory/NavigationSubcategory';
import Link from '~/src/components/link/Link';
import Boomerang from '~/src/components/svg/general/Boomerang';
import {TeaserLayoutProps} from '~/src/components/teaser/layout/default/TeaserLayoutDefault';

import {classNames} from '~/src/utilities/helpers/css';
import {SectionLayout} from '~/src/utilities/constants/layout';
import {getCategoryUrl} from '~/src/utilities/helpers/link';
import {createNavigationTracker} from '~/src/utilities/tracking/gtm';

import css from './TeaserLayoutVideo.module.scss';

const TeaserLayoutVideo = ({children, title, showTitle = false, format, layout, pointerCategoryID, fullUrlPath}: TeaserLayoutProps) => {
    const headerClassNames = classNames(css, 'titleHeader');
    const teaserClassNames = classNames(css, 'teasers');

    return (
        <React.Fragment>
            {showTitle && (
                <div className={headerClassNames}>
                    <h1 className={css.title}>
                        <Link className={css.titleLink} href={getCategoryUrl(fullUrlPath)} onClick={createNavigationTracker(4, title, pointerCategoryID)}>
                            {title}
                            <Boomerang />
                        </Link>
                    </h1>

                    {layout === SectionLayout.SUB_NAVIGATION && <NavigationSubcategory categoryId={pointerCategoryID} inTeaserSection={true} />}
                </div>
            )}

            <div className={teaserClassNames}>{children}</div>
        </React.Fragment>
    );
};

export default TeaserLayoutVideo;
